import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Card, Col } from "reactstrap";
import { useForm } from "react-hook-form";
import ApiService from "../../../services/apiService";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import routes from "../../../routers/routes";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { updatePasswordTitle, usersTitle } from "../../../constants";
const UpdatePassword = () => {
  const navigate = useNavigate();
  const { Id } = useParams();
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const togglePassword = () => setPasswordVisible(!isPasswordVisible);
  const toggleConfirmPassword = () => setConfirmPasswordVisible(!isConfirmPasswordVisible);

  const onSubmit = async (data: any) => {
    try {
      const updateData = {
        CurrentPassword: data.CurrentPassword,
        NewPassword: data.NewPassword,
        id : Id,
      };

      const response = await ApiService.axiosApi(`auth/password`, {
        method: 'PUT',
        data: updateData
      });

      if (response.success) {
        toast.success("Password updated successfully");
        navigate(routes.Users);
      } else {
        toast.error(response.data.message || "Failed to update password");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to update password");
    }
  };

  return (
    <>
    
    <div className="" style = {{width:'50%',height:"320px"}}>
      <Card className="p-5 pt-1" style={{height:"320px"}}>
        <CommonCardHeader title="Update Password" headClass="pb-3" />
       
          <Form onSubmit={handleSubmit(onSubmit)} style={{height:"320px"}}>
            <FormGroup>
              <Label className="col-form-label">Old Password</Label>
              <div className="form-input position-relative">
                <input
                  className="form-control"
                  type={isPasswordVisible ? "text" : "password"}
                  {...register("CurrentPassword", {
                    required: "Password is required",
                  
                  })}
                />
                <div className="show-hide" onClick={togglePassword}>
                  <span className={!isPasswordVisible ? "show" : ""}></span>
                </div>
              </div>
              {errors.Password && <p className="text-danger mt-1">{errors.Password.message?.toString()}</p>}
            </FormGroup>

            <FormGroup>
              <Label className="col-form-label">New Password</Label>
              <div className="form-input position-relative">
                <input
                  className="form-control"
                  type={isConfirmPasswordVisible ? "text" : "password"}
                  {...register("NewPassword", {
                    required: "Please Enter a new password",
                   
                  })}
                />
                <div className="show-hide" onClick={toggleConfirmPassword}>
                  <span className={!isConfirmPasswordVisible ? "show" : ""}></span>
                </div>
              </div>
              {errors.ConfirmPassword && <p className="text-danger mt-1">{errors.ConfirmPassword.message?.toString()}</p>}
            </FormGroup>

            <div className="form-group mb-0">
              <div className="d-flex justify-content-start mt-4 ">
              <Button color="primary" type="submit" className="me-2">
                  Update Password
                </Button>
                <Button color="danger" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                
              </div>
            </div>
          </Form>
       
      </Card>
    </div>
    </>
  );
};

export default UpdatePassword;